// extracted by mini-css-extract-plugin
export default {"signInFormWrapper":"sign-in-form-layout_signInFormWrapper__GbJZl"};